import React, { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  Modal,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  FormControlLabel,
  Menu,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { IoFilter } from "react-icons/io5";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { HiDotsHorizontal } from "react-icons/hi";
import { CiExport, CiImport } from "react-icons/ci";
import { LiaTrashAlt } from "react-icons/lia";
import CustomTable from "../../../components/CustomTable";
import Pagination from "../../../components/Pagination";
import dayjs from "dayjs";
import CustomModal from "../../../components/CustomModal";
import { useTheme } from "../../../style/theme";
import { IoMdExpand, IoMdContract } from "react-icons/io"; // Icons for maximize/minimize

export default function Jobs() {
  const [filterModal, setFilterModal] = useState(false);
  const [addJobModal, setAddJobModal] = useState(false);
  const [editJobModal, setEditJobModal] = useState(false);
  const [viewJobModal, setViewJobModal] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const fields = [
    { label: "Job Name", field: "jobName" },
    { label: "Project", field: "project" },
    { label: "Start Date", field: "startDate" },
    { label: "End Date", field: "endDate" },
    { label: "Hours", field: "hours" },
    { label: "Rate Per Hour", field: "ratePerHour" },
    { label: "Description", field: "description" },
    { label: "Attachment", field: "attachment" },
    { label: "Reminder", field: "reminder" },
    { label: "Reminder Time", field: "reminderTime" },
    { label: "Assignees", field: "assignees" },
    { label: "Status", field: "status" },
    { label: "Job Owner", field: "jobOwner" },
    { label: "Billable Status", field: "billableStatus" },
    { label: "Added By", field: "addedBy" },
    { label: "Added Time", field: "addedTime" },
    { label: "Modified By", field: "modifiedBy" },
    { label: "Modified Time", field: "modifiedTime" },
  ];

  const [filterFormValues, setFilterFormValues] = useState({
    search: "",
    filterFields: [],
  });
  const handleFilterFormChange = (name, value) => {
    setFilterFormValues((prev) => ({ ...prev, [name]: value }));
  };
  const handleFilterValueChange = (field, condition, value) => {
    setFilterFormValues((prev) => ({
      ...prev,
      filterFields: prev.filterFields.map((item) =>
        item.field === field ? { ...item, condition, value } : item
      ),
    }));
  };
  const handleCheckboxChange = (field) => (event) => {
    const checkedFields = filterFormValues.filterFields;
    if (event.target.checked) {
      setFilterFormValues((prev) => ({
        ...prev,
        filterFields: [...checkedFields, { field, condition: "is", value: "" }],
      }));
    } else {
      setFilterFormValues((prev) => ({
        ...prev,
        filterFields: checkedFields.filter((item) => item.field !== field),
      }));
    }
  };
  const handleFilterFormSubmit = (e) => {
    e.preventDefault();
    console.log("Filter Data :- ", filterFormValues);
    setFilterModal(false);
  };

  const [menuAnchor, setMenuAnchor] = useState(null);
  const isMenuopen = Boolean(menuAnchor);

  const columns = [
    { header: "Job Name", accessorKey: "jobName", enableSorting: true },
    { header: "Project", accessorKey: "project", enableSorting: true },
    { header: "Start Date", accessorKey: "startDate", enableSorting: true },
    { header: "End Date", accessorKey: "endDate", enableSorting: true },
    { header: "Hours", accessorKey: "hours", enableSorting: true },
    {
      header: "Rate Per Hour",
      accessorKey: "ratePerHour",
      enableSorting: true,
    },
    { header: "Description", accessorKey: "description", enableSorting: true },
    { header: "Attachment", accessorKey: "attachment", enableSorting: true },
    { header: "Reminder", accessorKey: "reminder", enableSorting: true },
    {
      header: "Reminder Time",
      accessorKey: "reminderTime",
      enableSorting: true,
    },
    { header: "Assignees", accessorKey: "assignees", enableSorting: true },
    { header: "Status", accessorKey: "status", enableSorting: true },
    { header: "Job Owner", accessorKey: "jobOwner", enableSorting: true },
    {
      header: "Billable Status",
      accessorKey: "billableStatus",
      enableSorting: true,
    },
    { header: "Added By", accessorKey: "addedBy", enableSorting: true },
    { header: "Added Time", accessorKey: "addedTime", enableSorting: true },
    { header: "Modified By", accessorKey: "modifiedBy", enableSorting: true },
    {
      header: "Modified Time",
      accessorKey: "modifiedTime",
      enableSorting: true,
    },
    { header: "Actions", accessorKey: "actions" },
  ];

  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedValue, setSelectedValue] = useState("one"); // Default value set

  const handleRowClick = (row) => {
    setViewJobModal(true);
  };
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [rowSelection, setRowSelection] = useState({});
  const [sorting, setSorting] = useState([{ id: "id", desc: false }]);

  const renderRowSelection = (table) => {
    return (
      <div>
        {Object.keys(rowSelection).length > 0 && (
          <Button variant="contained" color="error" onClick={() => {}}>
            Delete
          </Button>
        )}
      </div>
    );
  };

  const renderActions = (row) => (
    <IconButton>
      <LiaTrashAlt />
    </IconButton>
  );

  const handleSort = (column, direction) => {
    fetchData(column, direction);
  };
  const fetchData = async (sortBy = "", sortOrder = "") => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `https://reqres.in/api/users?page=${currentPage}&per_page=${limit}&${sortBy}=${sortOrder}`
      );
      const result = await response.json();
      if (result && result?.data && result?.total) {
        setData(result?.data);
        setTotalItems(result.total);
      }
    } catch (error) {
      setError("Error Fetching Data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // fetchData();
  }, [currentPage, limit]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };
  const totalPages = Math.ceil(totalItems / limit);

  const addJobModalFields = [
    {
      type: "text",
      name: "jobName",
      label: "Job Name",
      defaultValue: "",
    },
    {
      type: "autocomplete",
      name: "project",
      label: "Project",
      options: ["Project 1", "Project 2"],
      defaultValue: "",
    },

    {
      type: "datePicker",
      label: "Start Date",
      name: "startDate",
      defaultValue: dayjs("2023-10-01"),
      // disabled,
    },
    {
      type: "datePicker",
      label: "End Date",
      name: "endDate",
      defaultValue: dayjs("2023-10-01"),
      // disabled,
    },
    {
      type: "text",
      name: "hours",
      label: "Hours",
      defaultValue: "00:00",
      disabled: true,
    },
    {
      type: "text",
      name: "ratePerHour",
      label: "Rate Per Hour",
      defaultValue: "",
    },
    {
      type: "text",
      name: "description",
      label: "Description",
      defaultValue: "",
    },
    {
      type: "checkbox",
      name: "reminder",
      label: "Reminder",
      defaultValue: "",
    },
    {
      type: "select",
      name: "billableStatus",
      label: "Billable Status",
      options: [
        { label: "Billable", value: "billable" },
        { label: "Non-billable", value: "non-billable" },
        { label: "Select", value: "select" },
      ],
      defaultValue: "select",
    },
  ];
  const handleAddJobFormSubmit = (data) => {
    console.log("Add Form :- ", data);
  };

  const editJobModalFields = [
    {
      type: "text",
      name: "jobName",
      label: "Job Name",
      defaultValue: "Iml",
    },
    {
      type: "autocomplete",
      name: "project",
      label: "Project",
      options: ["Project 1", "Project 2"],
      defaultValue: "Project 1",
    },

    {
      type: "datePicker",
      label: "Start Date",
      name: "startDate",
      defaultValue: dayjs("2025-10-01"),
      // disabled,
    },
    {
      type: "datePicker",
      label: "End Date",
      name: "endDate",
      defaultValue: dayjs("2025-10-01"),
      // disabled,
    },
    {
      type: "text",
      name: "hours",
      label: "Hours",
      defaultValue: "00:00",
      disabled: true,
    },
    {
      type: "text",
      name: "ratePerHour",
      label: "Rate Per Hour",
      defaultValue: "0.00",
    },
    {
      type: "text",
      name: "description",
      label: "Description",
      defaultValue: "Description Data",
    },
    {
      type: "checkbox",
      name: "reminder",
      label: "Reminder",
      defaultValue: "checked",
    },
    {
      type: "select",
      name: "billableStatus",
      label: "Billable Status",
      options: [
        { label: "Billable", value: "billable" },
        { label: "Non-billable", value: "non-billable" },
        { label: "Select", value: "select" },
      ],
      defaultValue: "Billable",
    },
  ];
  const handleEditJobFormSubmit = (data) => {
    console.log("Edit Form :- ", data);
  };

  const viewJobModalFields = [
    {
      type: "text",
      name: "jobName",
      label: "Job Name",
      defaultValue: "Iml",
      disabled: true,
    },
    {
      type: "autocomplete",
      name: "project",
      label: "Project",
      options: ["Project 1", "Project 2"],
      defaultValue: "Project 1",
      disabled: true,
    },

    {
      type: "datePicker",
      label: "Start Date",
      name: "startDate",
      defaultValue: dayjs("2025-01-01"),
      disabled: true,
      // disabled,
    },
    {
      type: "datePicker",
      label: "End Date",
      name: "endDate",
      defaultValue: dayjs("2025-05-01"),
      disabled: true,
      // disabled,
    },
    {
      type: "text",
      name: "hours",
      label: "Hours",
      defaultValue: "00:00",
      disabled: true,
    },
    {
      type: "text",
      name: "ratePerHour",
      label: "Rate Per Hour",
      defaultValue: "0.00",
      disabled: true,
    },
    {
      type: "text",
      name: "description",
      label: "Description",
      defaultValue: "Description Data",
      disabled: true,
    },
    {
      type: "text",
      name: "reminder",
      label: "Reminder",
      defaultValue: "No",
      disabled: true,
    },
    {
      type: "text",
      name: "reminderTime",
      label: "Reminder Time",
      defaultValue: "-",
      disabled: true,
    },
    {
      type: "select",
      name: "billableStatus",
      label: "Billable Status",
      options: [
        { label: "Billable", value: "billable" },
        { label: "Non-billable", value: "non-billable" },
        { label: "Select", value: "select" },
      ],
      defaultValue: "Billable",
      disabled: true,
    },
  ];

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const [activeTab, setActiveTab] = useState("employee");
  const { mode } = useTheme();
  return (
    <div className="w-full min-h-80 flex flex-col mt-[40px]">
      <div className="flex flex-col md:flex-row gap-3 justify-between items-center mx-4">
        <div className="flex flex-row gap-3 justify-center items-center">
          <div>
            <FormControl sx={{ width: { md: "250px", xs: "150px" } }}>
              <Select
                labelId="table-view"
                id="table-view"
                value={selectedValue} // Selected value ko control kar raha hai
                onChange={(e) => setSelectedValue(e.target.value)}
                sx={{
                  height: "40px",
                  backgroundColor: mode === "light" ?"white":"",
                }}
              >
                <MenuItem value="one">One</MenuItem>
                <MenuItem value="two">Two</MenuItem>
                <div className="w-full">
                  <Button
                    sx={{ width: "100%" }}
                    onClick={() => {
                      // setCreateTableViewModal(true);
                    }}
                    variant="outlined"
                  >
                    Create Table View
                  </Button>
                </div>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="flex flex-row gap-3  justify-center items-center">
          {/* <FormControl sx={{ width: { md: "200px", xs: "100px" } }}>
            <InputLabel id="data">Data</InputLabel>
            <Select labelId="data" id="data" label="Data">
              <MenuItem value={"allData"}>All Data</MenuItem>
              <MenuItem value={"reporteesPlusMyData"}>
                Reportees + My Data
              </MenuItem>
              <MenuItem value={"reporteesData"}>Reportees Data</MenuItem>
              <MenuItem value={"directReporteesData"}>
                Direct Reportees Data
              </MenuItem>
              <MenuItem value={"myData"}>My Data</MenuItem>
            </Select>
          </FormControl> */}

          <div className="flex items-center">
            {/* Employee Tab */}
            <button
              className={`px-4 py-1 text-[14px] border rounded-[2px] h-[32px] ${
                activeTab === "employee"
                  ? `${mode === "light" ? "bg-white text-black" :""} border-blue-500 `
                  :  `${mode === "light" ? "bg-gray-200" :""} text-gray-500`
              }`}
              onClick={() => setActiveTab("employee")}
            >
              Employee
            </button>

            {/* Department Tab */}
            <button
              className={`px-4 text-[14px] py-1 h-[32px] border rounded-[2px] ${
                activeTab === "department"
                  ? ` border-blue-500 ${mode === "light" ? "text-black" :""}`
                  : `${mode === "light" ? "bg-gray-200" :""} text-gray-500`
              }`}
              onClick={() => setActiveTab("department")}
            >
              Department
            </button>
          </div>

          <Button
            variant="contained"
            onClick={() => {
              setAddJobModal(true);
            }}
            sx={{
              fontSize: { md: "15px", xs: "12px" },
              height: "32px",
              backgroundColor: "#0088ff",
            }}
          >
            Add Job
          </Button>

          {/* Maximize/Minimize Button */}
          <IconButton onClick={toggleFullscreen} >
            {isFullscreen ? (
              <IoMdContract size={24} />
            ) : (
              <IoMdExpand size={24} />
            )}
          </IconButton>

          <IconButton
            onClick={() => {
              setFilterModal(true);
            }}
            title="Filter"
          >
            <IoFilter />
          </IconButton>
          <div>
            <IconButton
              id="basic-button"
              aria-controls={isMenuopen ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={isMenuopen ? "true" : undefined}
              onClick={(event) => {
                setMenuAnchor(event.currentTarget);
              }}
            >
              <HiDotsHorizontal className="text-2xl" />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={menuAnchor}
              open={isMenuopen}
              onClose={() => {
                setMenuAnchor(null);
              }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem>
                <div className="flex flex-row gap-3 justify-between items-center">
                  <CiImport className="text-2xl" />
                  <h1>Import</h1>
                </div>
              </MenuItem>
              <MenuItem>
                <div className="flex flex-row gap-3 justify-between items-center">
                  <CiExport className="text-2xl" />
                  <h1>Export</h1>
                </div>
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>

      {/* Text Based on Active Tab */}

      {activeTab === "employee" ? (
        <div>
          <div className="h-[35.1rem] mt-1 overflow-scroll">
            {/* <CustomTable
                    // columns={columns}
                    // onRowClick={handleRowClick}
                    // renderActions={renderActions}
                    // data={data}
                    // loading={loading}
                    // error={error}
                    // onSort={handleSort}
                    columns={columns}
                    onRowClick={handleRowClick}
                    renderActions={renderActions}
                    renderRowSelection={renderRowSelection}
                    data={data}
                    loading={loading}
                    error={error}
                    // sorting={handleSort}
                    // setSorting={setSorting}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    pagination={pagination}
                    setPagination={setPagination}
                    totalRows={totalItems}
                    setTotalRows={setTotalItems}
                    isBulkSelect={true}
                  /> */}

            <CustomTable
              columns={columns}
              onRowClick={handleRowClick}
              renderActions={renderActions}
              renderRowSelection={renderRowSelection}
              data={data}
              loading={loading}
              error={error}
              sorting={sorting}
              setSorting={setSorting}
              rowSelection={rowSelection}
              setRowSelection={setRowSelection}
              pagination={pagination}
              setPagination={setPagination}
              totalRows={totalRows}
              setTotalRows={setTotalRows}
              isBulkSelect={false}
            />
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
        </div>
      ) : (
        <div
          className={`flex flex-col justify-center py-7 mx-4 items-center rounded-md mt-[30px] border 
          border-[#d7e2ed] ${mode === "light" ? "bg-[#f7f9fc]" : ""}`}
        >
          <img
            style={{ width: "240px", marginBottom: "20px" }}
            src="/images/no_timeLogs.png"
            alt=""
          />

          <p className=" text-[16px] font-[500] text-center mt-2">
            No Jobs added currently. To add new Jobs, click Add Job
          </p>
        </div>
      )}

      <CustomModal
        title="Add Job"
        fields={addJobModalFields}
        open={addJobModal}
        onClose={() => {
          setAddJobModal(false);
        }}
        onSubmit={handleAddJobFormSubmit}
        isScrollable={true}
        isCustomSubmitButtom={true}
        customSubmitButton={
          <div className="w-full flex flex-row justify-between items-center">
            <Button variant="contained" type="submit">
              Submit
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setAddJobModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        }
      />
      <CustomModal
        title="Edit Job"
        fields={editJobModalFields}
        open={editJobModal}
        onClose={() => setEditJobModal(false)}
        onSubmit={handleEditJobFormSubmit}
        isScrollable={true}
      />
      <CustomModal
        title="View Job"
        fields={viewJobModalFields}
        open={viewJobModal}
        onClose={() => setViewJobModal(false)}
        isView={true}
        isScrollable={true}
        isEditButton={true}
        onEditButtonClick={() => {
          setViewJobModal(false);
          setEditJobModal(true);
        }}
      />

      <CustomModal
        title="Filter"
        open={filterModal}
        onClose={() => setFilterModal(false)}
        // onSubmit={handleFilterFormSubmit}
        isScrollable={true}
      >
        <form onSubmit={handleFilterFormSubmit} className="flex flex-col gap-3">
          <div>
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="systemFilters"
                id="systemFilters"
              >
                <Typography component="span">Search</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TextField
                  sx={{ width: "100%" }}
                  variant="outlined"
                  label="Search"
                  placeholder="Search"
                  value={filterFormValues.search}
                  onChange={(e) =>
                    handleFilterFormChange("search", e.target.value)
                  }
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <div>
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography component="span">Field</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="flex flex-col gap-3">
                  {fields.map((field, index) => (
                    <div key={index}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleCheckboxChange(field.field)}
                              checked={filterFormValues.filterFields.some(
                                (item) => item.field === field.field
                              )}
                            />
                          }
                          label={field.label}
                        />
                      </FormGroup>

                      {filterFormValues.filterFields
                        .filter((item) => item.field === field.field)
                        .map((filter, idx) => (
                          <div className="flex flex-col gap-3" key={idx}>
                            <FormControl sx={{ width: "100%" }}>
                              <InputLabel id={`filter-${index}`}>
                                Condition
                              </InputLabel>
                              <Select
                                labelId={`filter-${index}`}
                                id={`filter-${index}`}
                                label="Condition"
                                value={filter.condition}
                                onChange={(e) =>
                                  handleFilterValueChange(
                                    field.field,
                                    e.target.value,
                                    filter.value
                                  )
                                }
                              >
                                <MenuItem value={"is"}>Is</MenuItem>
                                <MenuItem value={"isNot"}>Is Not</MenuItem>
                                <MenuItem value={"startWith"}>
                                  Start With
                                </MenuItem>
                                <MenuItem value={"endWith"}>End With</MenuItem>
                                <MenuItem value={"contains"}>Contains</MenuItem>
                                <MenuItem value={"notContains"}>
                                  Not Contains
                                </MenuItem>
                                <MenuItem value={"Like"}>Like</MenuItem>
                                <MenuItem value={"isEmpty"}>Is Empty</MenuItem>
                                <MenuItem value={"isNotEmpty"}>
                                  Is Not Empty
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <TextField
                              sx={{ width: "100%" }}
                              variant="outlined"
                              label="Value"
                              placeholder="Value"
                              value={filter.value}
                              onChange={(e) =>
                                handleFilterValueChange(
                                  field.field,
                                  filter.condition,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        ))}
                    </div>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          </div>

          <div className="w-full flex gap-2 flex-row justify-between items-center">
            <Button type="submit" variant="contained">
              Apply
            </Button>
            <Button
              onClick={() => {
                setFilterModal(false);
              }}
              variant="outlined"
            >
              Reset
            </Button>
          </div>
        </form>
      </CustomModal>
    </div>
  );
}
